// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eaa32957","239":"62be8bc2","732":"8d8e0653"}[chunkId] + ".chunk.js";
};